import React from "react";
import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepAuth from "components/Step/StepAuth";
import { getRelationshipStep } from "components/Step/StepRelationship";
import { normalizeAnswers, postAnswers } from "utils/GuidedSignUp";

export interface MembershipStepGetStartedProps extends MembershipState {
  suppressBackButton?: boolean;
}

export const MembershipStepGetStarted = ({
  contentfulQuizModelParsed,
  onSubmit,
  relationshipValues,
  routePrevStep,
  suppressBackButton = false,
  ...stepProps
}: MembershipStepGetStartedProps) => {
  const handleAuthenticationSuccess = async () => {
    // submission of initial relationship question is deferred until dummy account is created
    const relationshipStep = getRelationshipStep(contentfulQuizModelParsed);
    const normalizedAnswers = normalizeAnswers({
      answers: relationshipValues,
      step: relationshipStep,
    });

    // don't block funnel, fire and forget
    postAnswers({
      normalizedAnswers,
      quizSlug: contentfulQuizModelParsed.slug,
      quizVersion: contentfulQuizModelParsed.version,
      step: relationshipStep,
    });

    return onSubmit?.({
      kind: "get-started",
    });
  };

  const buttonProps = {
    backButtonProps: { onClick: () => routePrevStep?.() },
    suppressBackButton,
  };

  return (
    <StepAuth
      {...stepProps}
      onAuthenticationSuccess={handleAuthenticationSuccess}
      stepFooterProps={{ ...buttonProps }}
      stepHeaderProps={{ ...buttonProps }}
    />
  );
};

export const MEMBERSHIP_STEP_GET_STARTED: MembershipStep = {
  component: (state: MembershipState) => (
    <MembershipStepGetStarted {...state} />
  ),
  id: "membership-id-get-started",
  slug: "get-started",
};

export const MEMBERSHIP_STEP_GET_STARTED_SUPPRESS_BACK_BUTTON: MembershipStep =
  {
    ...MEMBERSHIP_STEP_GET_STARTED,
    component: (state: MembershipState) => (
      <MembershipStepGetStarted {...state} suppressBackButton />
    ),
  };

export default MembershipStepGetStarted;
